/*
 * Copyright (c) 2024. Dave van Rijn Development
 */
import './style/pdfImageSettings.scss';

import React, {PureComponent} from 'react';
import PdfImage from "../../image/pdfImage";
import {Button, DvrdButton, DvrdSelect, ElementPosition, SelectItemShape} from "../../../../../index";
import IconButton, {IconButtonType} from "../buttons/iconButton";
import {PDFDisplay} from "../../../util/interfaces";

interface Props {
    element: PdfImage;
    supportMultiPage: boolean;
}

interface State {
    alignment?: ElementPosition;
    display: PDFDisplay;
}

const displayItems: SelectItemShape[] = [
    {value: PDFDisplay.ALL_PAGES, label: 'Alle pagina\'s'},
    {value: PDFDisplay.FIRST_PAGE, label: 'Alleen eerste pagina'},
    {value: PDFDisplay.LAST_PAGE, label: 'Alleen laatste pagina'},
]

export default class PdfImageSettings extends PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        const settings = props.element.getSettings();
        this.state = {
            alignment: settings.alignment,
            display: settings.display ?? PDFDisplay.ALL_PAGES,
        };
    }

    onChangeDisplay = (value: PDFDisplay) => {
        const {element} = this.props;
        element.setSetting('display', value, () => {
            this.setState({display: value});
        })
    }

    onToggleAlignment = (type: IconButtonType) => () => {
        const {alignment} = this.state, {element} = this.props;
        let nextAlignment: ElementPosition | undefined;
        if (type === IconButtonType.LEFT)
            nextAlignment = alignment === ElementPosition.LEFT ? undefined : ElementPosition.LEFT;
        else if (type === IconButtonType.CENTER)
            nextAlignment = alignment === ElementPosition.CENTER ? undefined : ElementPosition.CENTER;
        else if (type === IconButtonType.RIGHT)
            nextAlignment = alignment === ElementPosition.RIGHT ? undefined : ElementPosition.RIGHT;
        element.setSetting('alignment', nextAlignment, () => {
            this.setState({alignment: nextAlignment});
        });
    }

    render = () => {
        const {element, supportMultiPage} = this.props, {alignment, display} = this.state;
        return (
            <div className='pdf-image-settings'>
                {supportMultiPage && <>
                    <label className='settings-title'>Pagina's</label>
                    <DvrdSelect onChange={this.onChangeDisplay} value={display} items={displayItems} unControlled/>
                </>}
                <div className='divider'/>
                <label className='settings-title'>Uitlijning</label>
                <div className='alignment'>
                    <IconButton onClick={this.onToggleAlignment} active={alignment === ElementPosition.LEFT}
                                type={IconButtonType.LEFT} title='Links'/>
                    <IconButton onClick={this.onToggleAlignment} active={alignment === ElementPosition.CENTER}
                                type={IconButtonType.CENTER} title='Centreren'/>
                    <IconButton onClick={this.onToggleAlignment} active={alignment === ElementPosition.RIGHT}
                                type={IconButtonType.RIGHT} title='Rechts'/>
                </div>
                <div className='divider'/>
                <DvrdButton onClick={element.onChooseFile} label='Kies afbeelding'/>
            </div>
        )
    }
}